import React, { useState } from "react";
import Select from "react-select";
import { BsCheckCircle } from "react-icons/bs";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { getNames } from "country-list";
import {
  FaUser,
  FaEnvelope,
  FaBriefcase,
  FaBuilding,
  FaMapMarkerAlt,
  FaCity,
  FaAddressCard,
} from "react-icons/fa";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import { Helmet } from "react-helmet-async";
import apiClient from "../config/apiClient";

const countryOptions = Object.entries(getNames()).map(([code, name]) => ({
  value: name,
  label: name,
}));
// 👇 BACKEND FORMAT KE LIYE MAPS
const businessTypeMap = {
  "Law Firm": "law_firm",
  "Tax Consultancy": "tax_consultancy",
  "SaaS Software Provider": "saas_software_provider",
  "Publishing House": "publishing_house",
  "IT Service Provider": "it_service_provider",
  "Educational Services": "educational_services",
  "Chartered Accountant": "chartered_accountant",
  "Lawyer": "lawyer",
  "Other": "other"
};

const clientsMap = {
  "Chartered Accountants": "chartered_accountants",
  "Lawyers/ Advocates": "lawyers_advocates",
  "Tax Consultants": "tax_consultants",
  "Government/PSU": "government_psu",
  "SMEs/MSMEs": "smes_msmes",
  "Educational Institutions": "educational_institutions",
  "Judicial Bodies": "judicial_bodies",
  "Corporates": "corporates",
  "Other": "other"
};

const marketingMap = {
  "Email Marketing": "email_marketing",
  "Social Media Campaigns": "social_media_campaigns",
  "Events/Seminars": "events_seminars",
  "Other": "other"
};
const businessTypes = [
  { value: "Law Firm", label: "Law Firm" },
  { value: "Tax Consultancy", label: "Tax Consultancy" },
  { value: "SaaS Software Provider", label: "SaaS Software Provider" },
  { value: "Publishing House", label: "Publishing House" },
  { value: "IT Service Provider", label: "IT Service Provider" },
  { value: "Educational Services", label: "Educational Services" },
  { value: "Chartered Accountant", label: "Chartered Accountant" },
  { value: "Lawyer", label: "Lawyer" },
  { value: "Other", label: "Other" },
];

const clientsOptions = [
  { value: "Chartered Accountants", label: "Chartered Accountants" },
  { value: "Lawyers/ Advocates", label: "Lawyers/ Advocates" },
  { value: "Tax Consultants", label: "Tax Consultants" },
  { value: "Government/PSU", label: "Government/PSU" },
  { value: "SMEs/MSMEs", label: "SMEs/MSMEs" },
  { value: "Educational Institutions", label: "Educational Institutions" },
  { value: "Judicial Bodies", label: "Judicial Bodies" },
  { value: "Corporates", label: "Corporates" },
  { value: "Other", label: "Other" },
];

const marketingOptions = [
  { value: "Email Marketing", label: "Email Marketing" },
  { value: "Social Media Campaigns", label: "Social Media Campaigns" },
  { value: "Events/Seminars", label: "Events/Seminars" },
  { value: "Other", label: "Other" },
];

const yearsOptions = [
  { value: "Less than 1 year", label: "Less than 1 year" },
  { value: "1-3 years", label: "1-3 years" },
  { value: "3-5 years", label: "3-5 years" },
  { value: "5+ years", label: "5+ years" },
];
const productOptions = [
  { value: "Expert", label: "Expert" },
  { value: "Intermediate", label: "Intermediate" },
  { value: "Beginner", label: "Beginner" },
  { value: "Not Familiar", label: "Not Familiar" },
];

const yesNoOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
const PartnerForm = () => {
  const [step, setStep] = useState(1);
  const [direction, setDirection] = useState("next");

  const [showPartnerSubmitted, setShowPartnerSubmitted] = useState(false);

  // const [formData, setFormData] = useState({
  //     businessName: '',
  //     businessType: [],
  //     businessTypeOther: '',
  //     yearsOperation: '',
  //     applicantName: '',
  //     applicantTitle: '',
  //     phone: '',
  //     email: '',
  //     address: '',
  //     city: '',
  //     state: '',
  //     existingClients: [],
  //     existingClientsOther: '',
  //     soldSaaSBefore: '',
  //     familiarity: '',
  //     hasSalesTeam: '',
  //     currentMarketing: [],
  //     currentMarketingOther: ''
  // });
  const initialFormData = {
    businessName: "",
    businessType: [],
    businessTypeOther: "",
    yearsOperation: "",
    applicantName: "",
    applicantTitle: "",
    phone: "",
    email: "",
    country: "",
    address: "",
    city: "",
    state: "",
    existingClients: [],
    existingClientsOther: "",
    soldSaaSBefore: "",
    familiarity: "",
    hasSalesTeam: "",
    currentMarketing: [],
    currentMarketingOther: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateStep = () => {
    if (step === 1) {
      return (
        formData.businessName &&
        formData.businessType.length &&
        formData.yearsOperation &&
        formData.applicantName &&
        formData.applicantTitle
      );
    }
    if (step === 2) {
      return (
        formData.phone &&
        formData.email &&
        formData.address &&
        formData.city &&
        formData.country
      );
    }
    if (step === 3) {
      return (
        formData.existingClients.length &&
        formData.soldSaaSBefore &&
        formData.familiarity &&
        formData.hasSalesTeam &&
        formData.currentMarketing.length
      );
    }
    return false;
  };

  const handleNext = () => {
    if (validateStep()) {
      setDirection("next");
      setStep((prev) => prev + 1);
    } else {
      alert("Please fill out all required fields in this step.");
    }
  };

  const handleBack = () => {
    setDirection("back");
    setStep((prev) => prev - 1);
  };
  const toBool = (v) => (v === "Yes" ? true : v === "No" ? false : null);
  const yearsMap = {
    "Less than 1 year": "less_than_1_year",  // 👈 Try this
    "1-3 years": "1_3_years",  // 👈 Try this
    "3-5 years": "3_5_years",  // 👈 Try this
    "5+ years": "5_plus_years",  // 👈 Try this
  };
  const familiarityMap = {
    Expert: "expert",
    Intermediate: "intermediate",
    Beginner: "beginner",
    "Not Familiar": "not_familiar",
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // setShowPartnerSubmitted(true);
    // setStep(0);

    if (!validateStep()) {
      alert("Please complete all fields before submitting.");
      return;
    }

    const apiData = {
      business_name: formData.businessName,
      business_types: formData.businessType.map((item) => businessTypeMap[item.value]),
      years_in_operation: yearsMap[formData.yearsOperation] ?? null,
      applicant_name: formData.applicantName,
      position_title: formData.applicantTitle,
      phone_e164: formData.phone,
      email: formData.email,
      country: formData.country,
      city: formData.city,
      state: formData.state,
      business_address: formData.address,
      existing_clients: formData.existingClients.map((item) => clientsMap[item.value]),
      other_clients_text: formData.existingClientsOther || "",
      previously_sold: toBool(formData.soldSaaSBefore),
      familiarity_level: familiarityMap[formData.familiarity] ?? null,
      has_sales_marketing_team: toBool(formData.hasSalesTeam),
      marketing_activities: formData.currentMarketing.map((item) => marketingMap[item.value]),
      other_marketing_text: formData.currentMarketingOther || "",
    };
    //   try {
    //     const response = await fetch(
    //       "https://simplifyte.com/partner-handler.php",
    //       {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify(formData),
    //       }
    //     );

    //     const result = await response.json();

    //     if (result.message === "Email sent successfully!") {
    //     }
    //   } catch (error) {
    //     console.error("Error:", error);
    //     alert("An error occurred while sending the email.");
    //   }
    // };

    try {
      const response = await apiClient.post('/partners/apply', apiData)
      if (response === 200 || response.status === 201) {
        setShowPartnerSubmitted(true);
        setStep(0)
        // console.log('API Response:', response.data);
      } else {
        alert(`Submission failed with Status${response.status}`)
      }
    } catch (error) {
      // console.log("API Error", error)
      if (error.response) {
        // Server responded with error status
        console.error('Error Response:', error.response.data);
        alert(`Error: ${error.response.data.message || 'Failed to submit form'}`);
      } else if (error.request) {
        // No response received
        console.error('No Response:', error.request);
        alert('Network error. Please check your connection and try again.');
      } else {
        // Something else went wrong
        console.error('Error:', error.message);
        alert('An unexpected error occurred. Please try again.');
      }
    }
  }

  const animationClass =
    direction === "next" ? "animate-slideIn" : "animate-slideInReverse";

  const isOtherSelected = (array) =>
    array.some((option) => option.value === "Other");

  return (
    <>
      <Helmet>
        <title>Apply For Partners | Simplifyte</title>

        {/* Open Graph meta */}
        <meta property="og:title" content="Apply For Partners | Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="Let’s grow, together."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/partnerform" />

        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte partners, apply for partnership, business collaboration, partner program, become a partner, SaaS partnership"
        />
      </Helmet>
      <div>
        <HeaderMenu />
        <section className="relative md:py-24 py-16">
          <div className="container relative mt-[50px]">
            <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 mt-10 gap-[30px]">
              <div className="lg:col-span-5 relative order-2">
                <div className="lg:ms-10">
                  <div className="bg-white dark:bg-slate-900 p-6 rounded-md shadow dark:shadow-gray-800">
                    <form onSubmit={handleSubmit}>
                      <div
                        key={step}
                        className={`grid grid-cols-1 gap-5 ${animationClass}`}
                      >
                        {step === 1 && (
                          <>
                            <Input
                              label="Business Information"
                              name="businessName"
                              placeholder="Company / Individual Name"
                              value={formData.businessName}
                              onChange={handleChange}
                              icon={FaBuilding}
                            />
                            <SelectField
                              label="Type of Business"
                              placeholder="Choose as many as you like"
                              options={businessTypes}
                              value={formData.businessType}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  businessType: value,
                                }))
                              }
                              isMulti
                            />
                            {isOtherSelected(formData.businessType) && (
                              <Input
                                label="Please specify other"
                                name="businessTypeOther"
                                placeholder="Specify other business type"
                                value={formData.businessTypeOther}
                                onChange={handleChange}
                              />
                            )}
                            <SelectField
                              label="Years in Operation"
                              placeholder="Select One"
                              options={yearsOptions}
                              value={yearsOptions.find(
                                (opt) => opt.value === formData.yearsOperation
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  yearsOperation: value.value,
                                }))
                              }
                            />
                            <Input
                              label="Full Name of Applicant"
                              name="applicantName"
                              placeholder="Enter your name"
                              value={formData.applicantName}
                              onChange={handleChange}
                              icon={FaUser}
                            />
                            <Input
                              label="Position/Title"
                              name="applicantTitle"
                              placeholder="Position in your organisation"
                              value={formData.applicantTitle}
                              onChange={handleChange}
                              icon={FaBriefcase}
                            />
                          </>
                        )}

                        {step === 2 && (
                          <>
                            <div>
                              <label className="form-label font-medium">
                                Phone Number:{" "}
                                <span className="text-red-600">*</span>
                              </label>
                              <div className="mt-2">
                                <PhoneInput
                                  country={"in"}
                                  value={formData.phone}
                                  onChange={(phone) =>
                                    setFormData((prev) => ({ ...prev, phone: phone ? `+${phone}` : "", }))
                                  }
                                  inputStyle={{
                                    width: "100%",
                                    height: "40px",
                                    borderRadius: "6px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "transparent",
                                    color: "#1e293b",
                                  }}
                                  dropdownStyle={{ zIndex: 10000 }}
                                />
                              </div>
                            </div>
                            <Input
                              label="Email"
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              icon={FaEnvelope}
                            />
                            <div>
                              <label className="form-label font-medium">
                                Country: <span className="text-red-600">*</span>
                              </label>
                              <Select
                                options={countryOptions}
                                value={countryOptions.find(
                                  (option) => option.value === formData.country
                                )}
                                onChange={(selected) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    country: selected.value,
                                  }))
                                }
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    backgroundColor: "transparent",
                                    borderRadius: "0.5rem",
                                    borderColor: "#e5e7eb",
                                    minHeight: "40px",
                                    boxShadow: "none",
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 10000,
                                    backgroundColor: "#fff",
                                    color: "#1e293b",
                                  }),
                                }}
                              />
                            </div>
                            <Input
                              label="City"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                              icon={FaCity}
                            />
                            <Input
                              label="State"
                              name="state"
                              value={formData.state}
                              onChange={handleChange}
                              icon={FaMapMarkerAlt}
                            />
                            <TextArea
                              label="Business Address"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                              icon={FaAddressCard}
                            />
                          </>
                        )}

                        {step === 3 && (
                          <>
                            <SelectField
                              label="Who are Your Existing Clients?"
                              placeholder="Choose as many as you like"
                              options={clientsOptions}
                              value={formData.existingClients}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  existingClients: value,
                                }))
                              }
                              isMulti
                            />
                            {isOtherSelected(formData.existingClients) && (
                              <Input
                                label="Please specify other clients"
                                name="existingClientsOther"
                                placeholder="Specify other client types"
                                value={formData.existingClientsOther}
                                onChange={handleChange}
                              />
                            )}
                            <SelectField
                              label="Have you previously sold SaaS, Legal, or Accounting/Taxation software?"
                              placeholder="Expertise & Experience"
                              options={yesNoOptions}
                              value={yesNoOptions.find(
                                (opt) => opt.value === formData.soldSaaSBefore
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  soldSaaSBefore: value.value,
                                }))
                              }
                            />
                            <SelectField
                              label="Familiarity with SaaS/Compliance products"
                              options={productOptions}
                              value={productOptions.find(
                                (opt) => opt.value === formData.familiarity
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  familiarity: value.value,
                                }))
                              }
                            />
                            <SelectField
                              label="Do you have a dedicated Sales/Marketing team?"
                              options={yesNoOptions}
                              value={yesNoOptions.find(
                                (opt) => opt.value === formData.hasSalesTeam
                              )}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  hasSalesTeam: value.value,
                                }))
                              }
                            />
                            <SelectField
                              label="Current marketing activities?"
                              placeholder="Choose as many as you like"
                              options={marketingOptions}
                              value={formData.currentMarketing}
                              onChange={(value) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  currentMarketing: value,
                                }))
                              }
                              isMulti
                            />
                            {isOtherSelected(formData.currentMarketing) && (
                              <Input
                                label="Please specify other marketing activities"
                                name="currentMarketingOther"
                                placeholder="Specify other marketing"
                                value={formData.currentMarketingOther}
                                onChange={handleChange}
                              />
                            )}
                          </>
                        )}

                        {showPartnerSubmitted && (
                          <>
                            <div className="bg-white text-center">
                              <div className="flex flex-col items-center space-y-4">
                                <div className="bg-green-100 rounded-full p-3">
                                  <svg
                                    className="h-6 w-6 text-green-500"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                </div>
                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
                                  ✨ Partnership Begins With Trust
                                </h4>
                                <hr className="w-full border-gray-200 dark:border-gray-700" />
                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
                                  Thanks for reaching out.
                                </h4>
                                <p className="text-gray-600 dark:text-gray-300 text-sm">
                                  Your application has been received, and Team
                                  Simplifyte is reviewing it with care. We'll
                                  soon be in touch to build something impactful
                                  together.
                                </p>
                                <button
                                  onClick={() => {
                                    setShowPartnerSubmitted(false);
                                    setFormData(initialFormData);
                                    setStep(1);
                                  }}
                                  className="w-full border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white font-semibold py-2 rounded"
                                >
                                  Done
                                </button>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="flex justify-between">
                          {step > 1 && !showPartnerSubmitted && (
                            <button
                              type="button"
                              onClick={handleBack}
                              className="px-4 py-1 font-semibold border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md"
                            >
                              Back
                            </button>
                          )}
                          {step < 3 && !showPartnerSubmitted ? (
                            <button
                              type="button"
                              onClick={handleNext}
                              className="px-4 py-1 font-semibold border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md"
                            >
                              Next
                            </button>
                          ) : showPartnerSubmitted ? null : (
                            <button
                              type="submit"
                              className="px-4 py-1 font-semibold border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md"
                            >
                              Submit
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="partner-square-anim square-anim overflow-hidden absolute lg:size-[400px] size-[320px] bg-indigo-600/5 bottom-0 end-0 rotate-45 -z-1 rounded-3xl"></div>
              </div>

              <div className="lg:col-span-7 order-1">
                <h1 className="font-size-same mb-6 md:text-3xl text-2xl font-semibold">
                  Let’s grow, together.
                </h1>
                <p className="text-slate-400">
                  Join our mission to simplify how the world works — one team at
                  a time.
                </p>
                <ul className="list-none text-slate-400 mt-4 space-y-2">
                  <li className="flex items-start">
                    <BsCheckCircle className="text-indigo-600 mt-1 me-2 shrink-0" />
                    <span className="text-slate-600">
                      <span className="font-semibold text-slate-900">
                        Apply Now
                      </span>{" "}
                      – Fill out a quick application to get started.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BsCheckCircle className="text-indigo-600 mt-1 me-2 shrink-0" />
                    <span className="text-slate-600">
                      <span className="font-semibold text-slate-900">
                        We Verify
                      </span>{" "}
                      – Our team carefully reviews your details.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BsCheckCircle className="text-indigo-600 mt-1 me-2 shrink-0" />
                    <span className="text-slate-600">
                      <span className="font-semibold text-slate-900">
                        Get Approved
                      </span>{" "}
                      – Once verified, you’re officially a partner.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BsCheckCircle className="text-indigo-600 mt-1 me-2 shrink-0" />
                    <span className="text-slate-600">
                      <span className="font-semibold text-slate-900">
                        Start Growing
                      </span>{" "}
                      – Access your dedicated panel & support to scale.
                    </span>
                  </li>
                </ul>
                <div className="mt-4">
                  <p className="text-slate-400">See you on the other side.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomFooter />
      </div>
    </>
  );
};

const Input = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  icon: Icon,
  placeholder,
}) => (
  <div>
    <label className="form-label font-medium">
      {label} <span className="text-red-500">*</span>
    </label>
    <div className="relative">
      {Icon && (
        <Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`form-input ps-12 w-full py-2 px-3 h-10 bg-transparent dark:bg-red-900 dark:text-slate-200 
          rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800
           dark:focus:border-indigo-600 focus:ring-0 ${Icon ? "pl-10" : ""
          }`}
        required
      />
    </div>
  </div>
);

const TextArea = ({ label, name, value, onChange, icon: Icon }) => (
  <div>
    <label className="form-label font-medium">
      {label} <span className="text-red-500">*</span>
    </label>
    <div className="relative">
      {Icon && <Icon className="absolute left-3 top-3 text-gray-400" />}
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        className={`form-input ps-12 w-full pl-10 pt-2 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0`}
        rows={3}
        required
      />
    </div>
  </div>
);

const SelectField = ({
  label,
  options,
  value,
  onChange,
  isMulti = false,
  placeholder = "Select",
}) => (
  <div>
    <label className="form-label font-medium">
      {label} <span className="text-red-500">*</span>
    </label>
    <Select
      options={options}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      className="react-select-container w-full bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200  dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0`"
      classNamePrefix="react-select"
      placeholder={placeholder}
    />
  </div>
);

export default PartnerForm;
